import ConfigRepository from '~repositories/ConfigRepository/ConfigRepository';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';

export class CartServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private configs: string[];

    constructor(configs: string[]) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.fetchConfigs(this.configs);
    };
}
